import { useRightPanel } from '../components/layouts/RightPanelContext';

/**
 * Hook to control the global right panel from anywhere in the app.
 * Content components manage their own chrome (header, scroll, footer) via RightPanelShell
 * or freely — the panel itself is just a fixed-width container.
 */
export const useRightPanelControl = () => {
  const { isOpen, toggle, open, close, content, setContent, panelWidth, setPanelWidth } = useRightPanel();

  const showOnboarding = (onboardingContent: React.ReactNode) => {
    setContent(onboardingContent);
    open();
  };

  const hideOnboarding = () => {
    close();
    setContent(null);
  };

  return {
    isOpen,
    toggle,
    open,
    close,
    content,
    setContent,
    panelWidth,
    setPanelWidth,
    showOnboarding,
    hideOnboarding
  };
};
